<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="py-8 mx-auto max-w-6xl lg:py-16">
      <div v-if="loading">
        <div role="status">
          <svg
            aria-hidden="true"
            class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-if="!loading" class="grid gap-4 px-4 mb-4 sm:mb-5 sm:grid-cols-3 sm:gap-6 md:gap-12">
        <div class="sm:col-span-2">
          <h2 class="flex items-center mb-4 text-xl font-bold leading-none text-gray-900 sm:text-2xl dark:text-white sm:mb-5">
            {{ contentInfo['content_type']['name'] }}
          </h2>
          <dl class="flex items-center mb-4 space-x-4 sm:mb-5">
            <div>
              <dt class="sr-only">
                Type
              </dt>
              <dd class="flex items-center text-gray-900 dark:text-white">
                <svg
                  class="w-4 h-4 mr-1.5 text-gray-400 dark:text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20">
                  <path d="m13.835 7.578-.005.007-7.137 7.137 2.139 2.138 7.143-7.142-2.14-2.14Zm-10.696 3.59 2.139 2.14 7.138-7.137.007-.005-2.141-2.141-7.143 7.143Zm1.433 4.261L2 12.852.051 18.684a1 1 0 0 0 1.265 1.264L7.147 18l-2.575-2.571Zm14.249-14.25a4.03 4.03 0 0 0-5.693 0L11.7 2.611 17.389 8.3l1.432-1.432a4.029 4.029 0 0 0 0-5.689Z" />
                </svg>

                <span class="font-semibold">Content Template</span>
              </dd>
            </div>
            <!-- <div>
                        <dt class="sr-only">Location</dt>
                        <dd class="flex items-center text-gray-900 dark:text-white">
                            <svg class="w-4 h-4 mr-1.5 text-gray-400 dark:text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path></svg>
                            <span class="font-semibold">California, USA</span>
                        </dd>
                    </div> -->
          </dl>
          <dl>
            <dt class="mb-2 font-semibold leading-none text-gray-900 dark:text-white">
              Details:
            </dt>
            <dd class="font-light text-gray-500 dark:text-gray-400">
              {{ contentInfo['content_type']['description'] }}
            </dd>
          </dl>
        </div>
        <!-- Column -->
        <dl class="p-4 bg-gray-50 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600">
          <dt class="mb-2 leading-none text-gray-500 dark:text-gray-400">
            Authors
          </dt>
          <dd class="flex mb-4 -space-x-4 sm:mb-5">
            <img class="w-8 h-8 rounded-full border-2 border-gray-50 dark:border-gray-700" src="https://growthfoundry.com/static/marketing/img/content/team-members/nate_fischer.png" alt="N Fischer">
            <button type="button" class="flex justify-center items-center w-8 h-8 text-xs font-medium text-white bg-gray-600 rounded-full border-2 border-gray-50 hover:bg-gray-500 dark:border-gray-700">
              +2
            </button>
          </dd>
          <dt class="mb-2 leading-none text-gray-500 dark:text-gray-400">
            Category
          </dt>
          <dd class="mb-4 font-medium text-gray-900 sm:mb-5 dark:text-white">
            {{ contentInfo['content_type']['category'] }}
          </dd>
          <!-- <dt class="mb-2 leading-none text-gray-500 dark:text-gray-400">Length</dt>
                <dd class="font-medium text-gray-900 dark:text-white">Generally 500 words</dd> -->
        </dl>
      </div>
      <!-- <div class="flex items-center px-4 space-x-4">
            <button type="button" class="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                <svg aria-hidden="true" class="mr-1 -ml-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"></path><path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd"></path></svg>
                Edit
            </button>
            <button type="button" class="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                Preview
            </button>
            <button type="button" class="inline-flex items-center text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-500 dark:hover:bg-red-600 dark:focus:ring-red-900">
                <svg aria-hidden="true" class="w-5 h-5 mr-1.5 -ml-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                Delete
            </button>
        </div> -->
    </div>
  </section>
</template>

<script setup>
import axios from 'axios'
import {
  ref, watch, onMounted, defineProps
} from 'vue'
import Multiselect from '@vueform/multiselect'

const props = defineProps({
  locationId: String,
  contentTypeId: String
})

const contentInfo = ref(null)
const loading = ref(true)

onMounted(() => {
  getInfo()
})

const getInfo = () => {
  axios.get(`/ajax/clients/ai_content/content_types/${props.contentTypeId}/info`).then((response) => {
    contentInfo.value = response.data
    loading.value = false
  }).catch((error) => {
    console.log(error)
  })
}
</script>
